// Use this controller in case tooltips are loaded later (in ajax sections for instance)

import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class TooltipsController extends Controller {
  connect() {
    this.tooltip = Tooltip.getOrCreateInstance(this.element);
  }

  disconnect() {
    this.tooltip?.dispose();
  }
}
